import { PageHero } from "../components/PageHero";
import { ContactForm } from "../components/ContactForm";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { CONTACT } from "../data/content";
import { Phone, Mail, MessageCircle, MapPin, Clock } from "lucide-react";

export default function Kontakt() {
  return (
    <>
      <Seo title="Kontakt" description="Kontaktieren Sie Energie-Tarifberater – per Telefon, E-Mail oder WhatsApp. Kostenlose Beratung, Rückruf oder Termin vereinbaren." path="/kontakt" />
      <PageHero
        eyebrow="Kontakt"
        titleLines={["Sprechen wir über", 'Ihre <span class="font-serif italic text-blue-700">Ersparnis.</span>']}
        subtitle="Rückruf, Termin oder Beratung – wählen Sie einfach den Weg, der Ihnen am liebsten ist."
        breadcrumb={[{ label: "Kontakt" }]}
      />

      <section className="bg-background py-24 sm:py-32">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 grid lg:grid-cols-2 gap-16">
          {/* Left: info */}
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-5">Direkter Draht</p>
            <h2 className="text-4xl font-heading font-semibold text-navy-900 leading-tight mb-10">
              Persönlich für Sie da.
            </h2>

            <div className="space-y-4">
              <a href={CONTACT.phoneHref} className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-6 hover:border-blue-300 transition-colors" data-testid="contact-phone">
                <span className="h-12 w-12 grid place-items-center rounded-xl bg-blue-50 text-blue-700"><Phone className="h-5 w-5" /></span>
                <div><p className="text-xs text-slate-400 uppercase tracking-wider">Telefon</p><p className="font-heading text-lg text-navy-900">{CONTACT.phone}</p></div>
              </a>
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-6 hover:border-blue-300 transition-colors" data-testid="contact-whatsapp">
                <span className="h-12 w-12 grid place-items-center rounded-xl bg-blue-50 text-blue-700"><MessageCircle className="h-5 w-5" /></span>
                <div><p className="text-xs text-slate-400 uppercase tracking-wider">WhatsApp</p><p className="font-heading text-lg text-navy-900">Foto der Rechnung senden</p></div>
              </a>
              <a href={CONTACT.emailHref} className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-6 hover:border-blue-300 transition-colors" data-testid="contact-email">
                <span className="h-12 w-12 grid place-items-center rounded-xl bg-blue-50 text-blue-700"><Mail className="h-5 w-5" /></span>
                <div><p className="text-xs text-slate-400 uppercase tracking-wider">E-Mail</p><p className="font-heading text-lg text-navy-900">{CONTACT.email}</p></div>
              </a>
              <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-6">
                <span className="h-12 w-12 grid place-items-center rounded-xl bg-blue-50 text-blue-700"><Clock className="h-5 w-5" /></span>
                <div><p className="text-xs text-slate-400 uppercase tracking-wider">Erreichbarkeit</p><p className="font-heading text-lg text-navy-900">{CONTACT.hours}</p></div>
              </div>
            </div>

            <div className="mt-8 rounded-2xl bg-blue-700 p-8 text-blue-50 text-sm leading-relaxed">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-blue-100 mt-0.5" />
                <div>
                  <p className="text-white font-medium">{CONTACT.company}</p>
                  <p>{CONTACT.onBehalf}</p>
                  <p>{CONTACT.street} · {CONTACT.city}</p>
                  <p className="mt-2 text-blue-200">{CONTACT.managing} · {CONTACT.register}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: form */}
          <div>
            <div className="rounded-[2rem] border border-slate-200 bg-white p-8 sm:p-10 shadow-[0_40px_80px_-40px_rgba(0,0,0,0.15)]">
              <h3 className="text-3xl font-heading font-semibold text-navy-900 mb-2">
                Schreiben Sie <span className="font-serif italic text-blue-700">uns.</span>
              </h3>
              <p className="text-slate-500 mb-8">Wir melden uns innerhalb von 24 Stunden.</p>
              <ContactForm testid="kontakt-form" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
